import PropTypes from 'prop-types';
import styled from 'styled-components';
import { LoadingIcon } from '@visionplanner/ui-react-material';
import { useLoader } from './busy-indicator-context';

/** This Component can be used to show loader at center of page
 * while the view is waiting for response from backend.
 * */
const BusyIndicator = ({ size = 80 }) => {
  const isLoading = useLoader();
  return (
    isLoading && (
      <StyledBusyIndicator>
        <LoadingIcon size={size} />
      </StyledBusyIndicator>
    )
  );
};

const StyledBusyIndicator = styled.div`
    display: flex;
    position: fixed;
    width: 100%;
    height: 100%;
    justify-content: center;
    align-items: center;
    z-index: 99;
`;

BusyIndicator.propTypes = {
  /** size of the busy indicator */
  size: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.oneOf(['xsmall', 'small', 'medium', 'large', 'xlarge']),
  ]),
};

export default BusyIndicator;
